import SkeletonBase from "newui/components/Skeleton";

interface EvaluationCriteriaStepProps {
	rfxId: number;
	rfxSubmissionId?: number;
	isLoading?: boolean;
}

export const EvaluationCriteriaStep: React.FC<EvaluationCriteriaStepProps> = ({
	rfxId,
	rfxSubmissionId,
	isLoading = false,
}) => {
	if (isLoading) {
		return (
			<div className="space-y-3">
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
			</div>
		);
	}

	return (
		<div data-testid="evaluation-criteria-step">
			<p className="text-sm text-gray-500 mb-4">
				Define the weighted criteria that will be used to score each supplier submission.
			</p>
			{/* TODO: Render evaluation criteria form when API is available */}
			<div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-gray-400 text-sm">
				Evaluation criteria configuration will appear here.
			</div>
		</div>
	);
};
